import * as sentry from "@sentry/react";

import { getSentryEnvironment } from "./getSentryEnvironment";
import { getSentrySampleRates } from "./getSentrySampleRates";
import { isSentryEnabled } from "./isSentryEnabled";
import { routeNameFromPath } from "./routeNameFromPath";

export default function initSentry() {
  const { tracesSampleRate, profileSessionSampleRate } = getSentrySampleRates();

  sentry.init({
    dsn: "https://f58ae101bf0f6cad2520590daeaa153b@o4508342913466368.ingest.us.sentry.io/4508342915563520",
    // Off for personal/local dev hosts so their in-flux errors don't flood Sentry.
    enabled: isSentryEnabled(),
    // at 0 these still hook fetch/XHR/history for nothing, so skip them
    integrations:
      tracesSampleRate > 0
        ? [
            sentry.browserTracingIntegration({
              beforeStartSpan: (options) => ({
                ...options,
                name: routeNameFromPath(options.name),
              }),
            }),
            sentry.browserProfilingIntegration(),
          ]
        : [],
    environment: getSentryEnvironment(),
    release: `fnreact_preNavRework`,
    tracesSampleRate,
    // decided once per tab, and only traced pages in that tab get profiled
    profileSessionSampleRate,
    // profiles automatically during traced page loads/navigations.
    profileLifecycle: "trace",
    ignoreErrors: [
      /^Non-Error promise rejection captured with value?/,
      /^cordova already defined?/,
      // Fixes FLOCKNOTE-REACT-WD5 (recaptcha error that doesn't affect users)
      "Missing required parameters: sitekey",
    ],
    denyUrls: [
      // Fixes FLOCKNOTE-REACT-WWT. Stax issue that doesn't affect us. It has to do with their digital wallets(google,apple pay that we don't use)
      /secure\.networkmerchants\.com/,
    ],
  });

  // Expose the sentry module (not the init() return value) so that setContext,
  // setUser, captureException, etc. are all available via window.Sentry.
  window.Sentry = sentry;
}
